import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Experiences from "./pages/Experiences";
import Events from "./pages/Events";
import CaptainsClub from "./pages/CaptainsClub";
import MembersLogin from "./pages/MembersLogin";
import MembersLounge from "./pages/MembersLounge";
import Gallery from "./pages/Gallery";
import MenuPage from "./pages/MenuPage";
import Policy from "./pages/Policy";
import Contact from "./pages/Contact";
import BookNow from "./pages/BookNow";
import Admin from "./pages/Admin";
import GiftPage from "./pages/GiftPage";
import GiftSuccess from "./pages/GiftSuccess";
import SharePage from "./pages/SharePage";
import ShareSuccess from "./pages/ShareSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="experiences" element={<Experiences />} />
            <Route path="events" element={<Events />} />
            <Route path="captains-club" element={<CaptainsClub />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="menu" element={<MenuPage />} />
            <Route path="policy" element={<Policy />} />
            <Route path="contact" element={<Contact />} />
            <Route path="book" element={<BookNow />} />
            <Route path="gift" element={<GiftPage />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
          <Route path="/members/login" element={<MembersLogin />} />
          <Route path="/members" element={<MembersLounge />} />
          <Route path="/gift/success" element={<GiftSuccess />} />
          <Route path="/share/success" element={<ShareSuccess />} />
          <Route path="/share/:bookingId" element={<SharePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
